module.exports = __webpack_public_path__ + "img/table32_02.a1c4f273.png";